import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateCheckUplist, MedicalcheckupList } from './store/index';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { IoIosCloseCircle } from 'react-icons/io';

const languages = ['English', 'Tamil', 'Hindi', 'Telugu', 'Malayalam', 'Kannada'];

const UpdateCheckUplist = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState('English');
  const [newCheckUp, setNewCheckUp] = useState(
    languages.reduce((acc, lang) => {
      acc[lang] = { name: '', content: '', reason: '', daysStart: '', daysEnd: '' };
      return acc;
    }, {})
  );  

  // Fetch Data and Populate State
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await dispatch(MedicalcheckupList(id));
        const fetchedData = response.payload.data;

        // Populate `newCheckUp` state
        const updatedFirstAid = languages.reduce((acc, lang) => {
          const langData = fetchedData.find((item) => item.collectionName.includes(lang.toLowerCase()));
          acc[lang] = {
            name: langData?.data?.name || '',
            content: langData?.data?.content || '',
            reason: langData?.data?.reason || '',
            daysStart: langData?.data?.daysStart || '',
            daysEnd: langData?.data?.daysEnd || '',
          };
          return acc;
        }, {});
        setNewCheckUp(updatedFirstAid);
      } catch (error) {
        console.error('Error fetching Checkup details:', error);
      }
    };
    fetchData();
  }, [dispatch, id]);

  // Handle Tab Change
  const handleTabChange = (lang) => setActiveTab(lang);

  // Handle Input Changes for each language
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewCheckUp((prev) => ({
      ...prev,
      [activeTab]: { ...prev[activeTab], [name]: value },
    }));
  };

  // Update Data
  const handleUpdateCheckUplist = async () => {
    const data = {
      ...newCheckUp,
      CheckupId: id, // Use the existing ID
    };    

    try {
      const response = await dispatch(updateCheckUplist(data));
      if (response.payload.message === 'Data updated successfully') {
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'CheckUp details have been updated successfully.',
        });
        navigate("/med_list")
      }
    } catch (error) {
      console.error('Failed to update first aid entry:', error);
    }
  };

  const isFormValid = newCheckUp[activeTab].name && newCheckUp[activeTab].content && newCheckUp[activeTab].reason;

  return (
    // <div className='icon_backButton'>
    //   <Link to="/med_list">
    //     <i className="fas fa-arrow-alt-circle-left"></i>
    //   </Link>
    //   <div className="containers">
    //     <h2>Edit Checkup Details</h2>
    //     <div className="tabers">
    //       {languages.map((lang) => (
    //         <button
    //           key={lang}
    //           onClick={() => handleTabChange(lang)}
    //           className="tabers"
    //           style={{
    //             backgroundColor: activeTab === lang ? '#4CAF50' : '#ccc',
    //           }}
    //         >
    //           {lang}
    //         </button>
    //       ))}
    //     </div>
    //     <div className="formContainers">
    //       <h3>{activeTab} Details</h3>
    //       <input
    //         type="text"
    //         name="name"
    //         className="inputs"
    //         value={newCheckUp[activeTab]?.name || ''}
    //         onChange={handleInputChange}
    //         placeholder="Enter Checkup Name"
    //       />
    //       <textarea
    //         name="content"
    //         className="textareas"
    //         value={newCheckUp[activeTab]?.content || ''}
    //         onChange={handleInputChange}
    //         style={{height:"100px"}}
    //         placeholder="Enter Checkup Content (HTML Format)"
    //       />
    //       <input
    //         type="text"
    //         name="reason"
    //         className="inputs"
    //         value={newCheckUp[activeTab]?.reason || ''}
    //         onChange={handleInputChange}
    //         placeholder="Enter Checkup reason"
    //       />
    //       <input
    //         type="text"
    //         name="daysStart"
    //         className="inputs"
    //         value={newCheckUp[activeTab]?.daysStart || ''}
    //         onChange={(e) => {
    //           const value = e.target.value;
    //           if (/^\d*$/.test(value)) {
    //             handleInputChange(e);
    //           }
    //         }}
    //         placeholder="Enter Days Start"
    //       />
    //       <input
    //           type="number"
    //           name="daysEnd"
    //           className="inputs"
    //           value={newCheckUp[activeTab]?.daysEnd || ''}
    //           onChange={(e) => {
    //             const value = e.target.value;
    //             if (/^\d*$/.test(value)) {
    //               handleInputChange(e);
    //             }
    //           }}
    //           placeholder="Enter Days End"
    //         />
    //     </div>
    //     <button
    //       className="saveButton"
    //       onClick={handleUpdateCheckUplist}
    //       disabled={!isFormValid}
    //     >
    //       Update
    //     </button>
    //   </div>
    // </div>

    <>
    <div className='container_alluser' >


      <div className="containers" style={{ marginTop: "20px" }}>
        <div className='title_close'>
          <h3 >Edit Checkup Details</h3>
          <Link to="/fruits">
            <IoIosCloseCircle className='close' />

          </Link>
        </div>
        <div className="tabers_container">
          {languages.map((lang) => (
            <button
              key={lang}
              onClick={() => handleTabChange(lang)}
              className="tabers"
              style={{
                backgroundColor: activeTab === lang ? '#4195ee' : '#d3d3d3',
                color: activeTab === lang ? '#fff' : '#000',
                fontWeight: "600"
              }}
            >
              {lang}
            </button>
          ))}
        </div>
        <div className='form_contents' style={{marginTop:"25px"}}>
          <div className="commonSection_lists">
          <h3 className='lang_title'>{activeTab} Details</h3>
          <input
            type="text"
            name="name"
            className="inputs"
            value={newCheckUp[activeTab]?.name || ''}
            onChange={handleInputChange}
            placeholder="Enter Checkup Name"
          />
          <input
            type="text"
            name="daysStart"
            className="inputs"
            value={newCheckUp[activeTab]?.daysStart || ''}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value)) {
                handleInputChange(e);
              }
            }}
            placeholder="Enter Days Start"
          />
          <input
              type="number"
              name="daysEnd"
              className="inputs"
              value={newCheckUp[activeTab]?.daysEnd || ''}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  handleInputChange(e);
                }
              }}
              placeholder="Enter Days End"
            />
          </div>
          <div className="formContainers">
           
            <div className='name_html'>
            <input
            type="text"
            name="reason"
            className="inputs"
            value={newCheckUp[activeTab]?.reason || ''}
            onChange={handleInputChange}
            placeholder="Enter Checkup reason"
          />
          <textarea
            name="content"
            className="textareas"
            value={newCheckUp[activeTab]?.content || ''}
            onChange={handleInputChange}
            style={{height:"100px"}}
            placeholder="Enter Checkup Content (HTML Format)"
          />
            </div>
          </div>
        </div>
        <div className='buttoncontainer'>
        <button
          className="saveButton"
          onClick={handleUpdateCheckUplist}
          disabled={!isFormValid}
        >
          Update
        </button>
        </div>
      </div>

    </div>

  </>
  );
};

export default UpdateCheckUplist;
